import { get } from 'lodash'

import { services } from '@/utils'

import routesTree from '@/components/trees/routes'

export default function(h) {
  if (this.routingGroups) {
    const routingGroup = get(this.value, 'meta._routing.routingGroup')
    const routingRule = get(this.value, 'meta._routing.routingRule')
    const providerGroup = get(this.value, 'meta._routing.providerGroup')
    const provider = get(this.value, 'meta._routing.provider')

    return h(
      'div',
      {
        class: `${services.sendings}-item__tabs-routing`
      },
      [
        h(
          routesTree,
          {
            props: {
              value: this.routingGroups || {},
              readonly: true,
              highlight: {
                routingGroups: [ routingGroup ].filter(Boolean),
                routingRules: [ routingRule ].filter(Boolean),
                providerGroups: [ providerGroup ].filter(Boolean),
                providers: [ provider ].filter(Boolean)
              }
            }
          }
        )
      ]
    )
  }
}
